/* eslint-disable no-restricted-globals */
import moduleRegistry from '../module-registry/module-registry';

const config = {
    selectors: {
        module: '.rfct-toggle-banner',
        toggleButtonContainer: '.rfct-toggle-banner__toggle-button-container',
        toggleButton: '.rfct-toggle-banner__toggle-button-container .rfct-button',
        toggleButtonLabel: '.rfct-toggle-banner__toggle-button-container .rfct-button .rfct-button__label',
        toggleButtonIcon: '.rfct-toggle-banner__toggle-button-container .rfct-button .rfct-button__icon',
        actionButton: '.rfct-toggle-banner__action-button-container .rfct-button',
        // helpButton: '.rfct-toggle-banner__help-button-container .rfct-button',
    },
    classNames: {
        open: 'rfct-toggle-banner--open',
    },
};

export default class ToggleBanner {
    constructor($rootElement) {
        this._$rootElement = $rootElement;
        this._elements = this._getDomElements();
    }

    _getDomElements() {
        return {
            $toggleButtonContainer: this._$rootElement.find(config.selectors.toggleButtonContainer),
            $toggleButton: this._$rootElement.find(config.selectors.toggleButton),
            $toggleButtonLabel: this._$rootElement.find(config.selectors.toggleButtonLabel),
            $toggleButtonIcon: this._$rootElement.find(config.selectors.toggleButtonIcon),
            $actionButton: this._$rootElement.find(config.selectors.actionButton),
            // $helpButton: this._$rootElement.find(config.selectors.helpButton),
        };
    }

    init() {
        this._addEventListeners();
        this._updateToggleButtonState();
    }

    _addEventListeners() {
        this._elements.$toggleButton.on('click', () => {
            this._toggleBanner();
        });

        this._elements.$actionButton.on('click', () => {
            this._close();
        });

        // this._elements.$helpButton.on('click', () => {
        //     this._close();
        // });
    }

    _toggleBanner() {
        if (this._isOpen()) {
            this._close();
        } else {
            this._open();
        }
    }

    _isOpen() {
        return this._$rootElement.hasClass(config.classNames.open);
    }

    _open() {
        this._$rootElement.addClass(config.classNames.open);
        this._updateToggleButtonState(true);
        this._$rootElement.trigger('rfct:togglebanneropen');
    }

    _close() {
        this._$rootElement.removeClass(config.classNames.open);
        this._updateToggleButtonState(false);
        this._$rootElement.trigger('rfct:togglebannerclose');
    }

    _updateToggleButtonState(open) {
        let isOpen = open;

        if (isOpen === undefined) {
            isOpen = this._isOpen();
        }

        this._setToggleButtonText(isOpen);
        this._setToggleButtonIcon(isOpen);
    }

    _setToggleButtonText(open) {
        const toggleButtonText = this._elements.$toggleButtonContainer.attr(open ? 'data-close-text' : 'data-open-text');

        if (!toggleButtonText) {
            return;
        }

        this._elements.$toggleButtonLabel.text(toggleButtonText);
    }

    _setToggleButtonIcon(open) {
        const toggleButtonIcon = this._elements.$toggleButtonContainer.attr(open ? 'data-close-icon' : 'data-open-icon');

        if (!toggleButtonIcon) {
            return;
        }

        this._elements.$toggleButtonIcon.text(toggleButtonIcon);
    }
}

moduleRegistry.registerModule('ToggleBanner', ToggleBanner);
moduleRegistry.autoApplyModule('ToggleBanner', config.selectors.module);